import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../index.module.scss';

interface IProps {}

export const EmptySearchMessage: FC<IProps> = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.emptyMessage}>
      <div className={styles.content}>
        <div className={styles.title}>{t('Common.yourSearchDidNotGiveAnyResults')}</div>
        <div className={styles.subTitle}>{t('Common.tryDifferentKeywords')}</div>
      </div>
    </div>
  );
};

export default EmptySearchMessage;
